// src/lib/journey-var-labels.js — libellés FR lisibles des variables du parcours.
//
// Affichés sur les chips de variables de l'éditeur du sous-onglet Direct
// (src/tabs/messages/DirectMessagesView.jsx). PUR AFFICHAGE.
//
// ⚠️ NE RENOMME PAS les variables : les clés `{xxx}` et le moteur d'emails
// (lib/journey-templates.js) sont strictement inchangés. Ce dico ne fait que
// traduire le NOM technique en explication lisible.
//
// Synonymes inter-générations de templates (ex. prenom/guestFirstName,
// logement/logementNom, from/startDate) → même libellé.
// Une variable absente du dico affiche juste son `{token}` (fallback silencieux).
// Le test journey-var-labels.test.js garantit qu'AUCUNE variable de
// JOURNEY_TEMPLATE_META ne reste sans libellé (anti-dérive).
export const VAR_LABELS_FR = {
  // 👤 Voyageur
  guestFirstName: 'prénom voyageur',
  prenom: 'prénom voyageur',
  guest_first_name: 'prénom voyageur',
  guestLastName: 'nom voyageur',
  guestEmail: 'email voyageur',
  guestPhone: 'téléphone voyageur',
  // 🏠 Séjour / dates
  logementNom: 'nom du logement',
  logement: 'nom du logement',
  logement_name: 'nom du logement',
  from: "date d'arrivée",
  startDate: "date d'arrivée",
  date_arrivee: "date d'arrivée",
  to: 'date de départ',
  endDate: 'date de départ',
  date_depart: 'date de départ',
  dates: 'dates du séjour',
  nbNuits: 'nombre de nuits',
  nbVoyageurs: 'nombre de voyageurs',
  checkinTime: "heure d'arrivée",
  checkoutTime: 'heure de départ',
  checkin_date: "date d'arrivée",
  checkout_date: 'date de départ',
  // 💶 Montants / caution
  montantLine: 'ligne montant du séjour',
  montantTotalLine: 'ligne montant total',
  montant: 'montant',
  tarifLine: 'ligne tarif (détail)',
  cautionLine: 'ligne caution',
  cautionAmount: 'montant caution',
  cautionAvailableFromLabel: "date d'ouverture caution",
  date_caution: 'date de la caution',
  // 📄 Réfs / politique / promo
  requestIdShort: 'réf. demande (courte)',
  request_ref: 'réf. demande (courte)',
  requestId: 'réf. demande (complète)',
  signatureId: 'réf. signature',
  insertedId: 'réf. enregistrement',
  politiqueAnnulationText: "texte politique d'annulation",
  politiqueAnnulation: "politique d'annulation (clé)",
  promoLine: 'ligne code promo',
  motifLine: 'ligne motif (rejet)',
  // 🔗 Liens / divers
  journeyUrl: 'lien parcours',
  lien: 'lien parcours',
  lien_livret: 'lien du livret',
  // M1 — lien STABLE de téléchargement du PDF du contrat signé.
  lien_contrat: 'lien du contrat signé (PDF)',
  // PR3 (double-booking) — lien vers la page publique du logement (site direct).
  lien_logement: 'lien de la page logement',
  avis_google_url: 'lien avis Google',
  hostLabel: 'libellé conciergerie/hôte',
  contactInfoLine: 'ligne contact conciergerie',
  // CHANTIER 0.1-A — fragment_contact_line : coordonnées assemblées (« tél ou
  // email », ou email seul si pas de téléphone configuré).
  contact: 'coordonnées de contact',
  messageSafe: 'message voyageur (texte libre)',
  manquants: 'éléments manquants (FR)',
  manquants_en: 'éléments manquants (EN)',
  // Lot « annulation deux types » (2026-07-20) — email cancelled_voyageur.
  cancelOrigin: "type d'annulation (guest/host)",
  cancelOriginLine: "ligne d'intro annulation (selon type)",
  // ── PARTIE B / B2 (ADR-272) — catalogue Direct : alias FR + variables créées +
  // drapeaux de conditions {#if}. Miroir de lib/direct-vars-catalog.js
  // (DIRECT_VAR_CATALOG). N'invente aucun rendu : pur libellé d'affichage.
  nb_nuits: 'nombre de nuits',
  nb_voyageurs: 'nombre de voyageurs',
  guest_email: 'email voyageur',
  guest_phone: 'téléphone voyageur',
  guest_last_name: 'nom voyageur',
  heure_arrivee: "heure d'arrivée (logement)",
  heure_depart: 'heure de départ (logement)',
  ville: 'ville du logement',
  date_veille_arrivee: "veille de l'arrivée",
  heure_arrivee_voyageur: "heure d'arrivée déclarée",
  caution_montant: 'montant de la caution',
  montant_rembourse: 'montant remboursé',
  montant_sejour: 'montant du séjour',
  // #21 « Dépôt de garantie restitué » — libellés MIROIR de DIRECT_VAR_CATALOG
  // (lib/direct-vars-catalog.js) : on ne renomme rien, on recopie.
  montant_preleve: 'montant prélevé sur la caution',
  montant_libere: 'montant de caution libéré',
  motif_prelevement: 'motif du prélèvement (caution)',
  reference_demande: 'référence de la demande',
  politique_annulation: "politique d'annulation",
  motif_rejet: 'motif de rejet',
  motif_annulation: "motif d'annulation",
  code_promo: 'code promo',
  promo_pourcentage: 'remise promo (%)',
  delai_reponse: 'délai de réponse annoncé',
  delai_paiement: 'délai de paiement',
  date_limite_paiement: 'date limite de paiement',
  lien_sejour: 'lien du séjour',
  lien_site_direct: 'lien site direct',
  lien_admin_demande: 'lien admin de la demande',
  message_voyageur: 'message du voyageur',
  email_contact: 'email de contact',
  telephone_contact: 'téléphone de contact',
  // Drapeaux de conditions (sans rendu texte — usage {#if …}).
  formulaire_manquant: 'formulaire non rempli',
  formulaire_rempli: 'formulaire rempli',
  caution_manquante: 'caution non reçue',
  caution_recue: 'caution reçue',
  caution_empreinte: 'caution = empreinte',
  caution_debit: 'caution = débit',
  caution_deposee: 'caution déposée',
  animaux_non: 'animaux non autorisés',
  fumeur_non: 'non-fumeur',
  motif_affiche: "motif d'annulation affiché",
  remboursement_effectue: 'remboursement effectué',
  aucun_remboursement: 'aucun remboursement',
  remboursement_total: 'remboursement total',
  remboursement_partiel: 'remboursement partiel',
  remboursement_aucun: 'remboursement nul',
};
